export * from './delete-zeit-art-request.interface';
export * from './delete-zeit-art-response.interface';
export * from './delete-zeit-art.shapes';
